import { IconButton } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { FillerGrid } from "./styles/Filler";

/**
 * O objetivo desse componente é ajudar a manter um padrão no front-end
 * no caso, ele serve para manter accordions do mesmo tamanho
 * na mesma linha, porém, vai vir a ser modificado para mais usos.
 */
const Filler = () => (
  <FillerGrid item>
    <IconButton>
      <AddIcon />
    </IconButton>
  </FillerGrid>
);

export default Filler;
